import { Container, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import { templateSelector } from 'redux/modules/template-wizard/selectors';
import { templateRequiresFlowSelection } from '../utils';
import TemplateConfirmation from './TemplateConfirmation';
import TemplateFlowSelector, {
  TemplateFlowSelectorProps,
} from './TemplateFlowSelector';
import TemplatePreview from './TemplatePreview';
import { block } from './utils';

export type TemplateWizardLandingPageProps = Pick<
  TemplateFlowSelectorProps,
  'onFlowSelect'
> & {
  onConfirmTemplateSelection: () => void;
};

const TemplateWizardLandingPage: React.FC<TemplateWizardLandingPageProps> = ({
  onConfirmTemplateSelection,
  onFlowSelect,
}) => {
  const template = useSelector(templateSelector);
  const showFlowSelector = templateRequiresFlowSelection(template);

  return (
    <div className={block()}>
      <Container
        as={Spacer}
        borderWeight={0}
        className={block('card')}
        cornerRadius="40px"
        gutter="0px"
        orientation="horizontal"
        space="0px"
      >
        <div className={block('preview-column')}>
          <TemplatePreview className={block('preview')} template={template} />
        </div>
        <div className={block('action-column')}>
          {showFlowSelector ? (
            <TemplateFlowSelector onFlowSelect={onFlowSelect} />
          ) : (
            <TemplateConfirmation onConfirm={onConfirmTemplateSelection} />
          )}
        </div>
      </Container>
    </div>
  );
};

export default TemplateWizardLandingPage;
